// extracted by mini-css-extract-plugin
module.exports = {"question":"Question_question__1JcNm","title":"Question_title__-gVa6","no":"Question_no__1YKx5","textarea":"Question_textarea__3Y4Ne"};